var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { clearAllBodyScrollLocks, disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import * as React from 'react';
import Button from '../button';
import Icon from '../icon';
import { Styled } from './style';
export var CloseButtonPosition;
(function (CloseButtonPosition) {
    CloseButtonPosition["LEFT"] = "LEFT";
    CloseButtonPosition["RIGHT"] = "RIGHT";
})(CloseButtonPosition || (CloseButtonPosition = {}));
export var ModalSize;
(function (ModalSize) {
    ModalSize["FIXSMALLHEIGHT"] = "fixsmallheight";
    ModalSize["FULLHEIGHT"] = "fullheight";
    ModalSize["FULLSCREEN"] = "fullscreen";
    ModalSize["LARGE"] = "large";
    ModalSize["MEDIUM"] = "medium";
    ModalSize["NORMAL"] = "normal";
    ModalSize["SCROLLABLE"] = "scrollable";
    ModalSize["SMALL"] = "small";
})(ModalSize || (ModalSize = {}));
var Modal = /** @class */ (function (_super) {
    __extends(Modal, _super);
    function Modal(props) {
        var _this = _super.call(this, props) || this;
        _this.close = function () {
            var canCLose = (!!_this.props.onBeforeClose ? _this.props.onBeforeClose() : Promise.resolve(true));
            canCLose.then(function (val) {
                if (val) {
                    if (_this.props.onClose) {
                        _this.props.onClose();
                        document.body.classList.remove('md-open');
                        enableBodyScroll(_this.targetElement);
                    }
                    _this.setState({
                        modalControl: 'md-modal',
                        mpdalParentControl: '',
                    });
                }
            });
        };
        _this.handleKeyPress = function (event) {
            var keyEvent = event.key;
            if (_this.props.keyPress && keyEvent === 'Escape') {
                _this.close();
            }
        };
        _this.myRef = React.createRef();
        _this.targetElement = null;
        _this.state = {
            modalControl: props.open ? 'md-modal md-show' : 'md-modal',
            mpdalParentControl: props.open ? 'md-modal md-parent-show' : '',
            open: props.open,
        };
        return _this;
    }
    Modal.getDerivedStateFromProps = function (nextProps, prevState) {
        if (nextProps.open) {
            document.body.classList.add('md-open');
            disableBodyScroll(document.querySelector('#modal-wrapper'));
        }
        if (nextProps.open !== prevState.open) {
            return {
                modalControl: nextProps.open ? 'md-modal md-show' : 'md-modal',
                mpdalParentControl: nextProps.open ? 'md-parent-show' : '',
                open: nextProps.open,
            };
        }
        return null;
    };
    Modal.prototype.componentDidMount = function () {
        this.targetElement = document.querySelector('#modal-wrapper');
        if (this.props.open && this.props.onOpen) {
            this.props.onOpen();
        }
    };
    Modal.prototype.componentWillUnmount = function () {
        document.body.classList.remove('md-open');
        clearAllBodyScrollLocks();
    };
    Modal.prototype.render = function () {
        var _a = this.props, id = _a.id, children = _a.children, className = _a.className, closeButtonPosition = _a.closeButtonPosition, overflow = _a.overflow, size = _a.size, title = _a.title, disableCloseButton = _a.disableCloseButton, closeOnDimmerClick = _a.closeOnDimmerClick, footer = _a.footer, customHeader = _a.customHeader;
        var modalClassname = "md-" + size + " " + (className ? className : '') + " " + (overflow ? 'md-allow-overflow' : '') + " " + this.state.mpdalParentControl;
        var showCloseButton = !disableCloseButton;
        return (React.createElement(Styled, { className: modalClassname, id: id },
            React.createElement("div", { className: "md-container", tabIndex: 0, ref: this.myRef, onKeyDown: this.handleKeyPress },
                React.createElement("div", { className: this.state.modalControl },
                    React.createElement("div", { className: "md-wrapper", id: "modal-wrapper" },
                        !customHeader &&
                            (React.createElement("div", { className: (title ? 'md-title' : 'md-no-title') + " " + (closeButtonPosition === CloseButtonPosition.LEFT ? 'left-sided' : '') },
                                title &&
                                    React.createElement("h3", null, title),
                                showCloseButton && React.createElement(Button, { className: "btn-close", transparent: true, onClick: this.close, title: "Close" },
                                    React.createElement(Icon, { name: "close" })))),
                        React.createElement("div", { className: "md-content" }, children),
                        footer && React.createElement("div", { className: "md-footer" },
                            React.createElement("div", null, footer)))),
                React.createElement("div", { className: "md-overlay", onClick: closeOnDimmerClick ? this.close : undefined }))));
    };
    Modal.defaultProps = {
        customHeader: false,
        disableCloseButton: false,
        closeOnDimmerClick: true,
        centerTitle: false,
        overflow: false,
        keyPress: true,
    };
    return Modal;
}(React.PureComponent));
export { Modal };
export default Modal;
//# sourceMappingURL=index.js.map